import { api } from '../commonApi';
import { ICreateCartItemFromMenuItemRequest } from '../../proto/cart/cartItem';
import { IGetCartResponse } from '../../proto/cart/cart';

const BASE_CART_URL = `/cart`;

export const cartApi = api.injectEndpoints({
	endpoints: (builder) => ({
		addItemToCart: builder.mutation<void, { item: ICreateCartItemFromMenuItemRequest }>({
			query: ({ item }) => ({
				url: `${BASE_CART_URL}/addItemToCart`,
				method: 'PUT',
				body: item,
				credentials: 'include',
			}),
			invalidatesTags: [{ type: `Cart` }],
		}),
		getUserCart: builder.query<IGetCartResponse, void>({
			query: () => {
				return `${BASE_CART_URL}`;
			},
			providesTags: () => [{ type: `Cart` }],
		}),
		removeItemFromCart: builder.mutation<void, { cartItemId: string }>({
			query: ({ cartItemId }) => ({
				url: `${BASE_CART_URL}/removeItemFromCart/${cartItemId}`,
				method: 'DELETE',
				credentials: 'include',
			}),
			invalidatesTags: [{ type: `Cart` }],
		}),
	}),
});

export const { useGetUserCartQuery, useAddItemToCartMutation, useRemoveItemFromCartMutation } = cartApi;
